import React, { useState } from 'react';

import { Text } from '@betterment/samba-react';
import { Flash } from '@betterment/style-closet-react';

interface Props {
  type: 'success' | 'error';
}

export const ExportBanner: React.FC<React.PropsWithChildren<Props>> = ({ type }) => {
  const [shouldShowBanner, setShouldShowBanner] = useState(true);

  const successText = 'Transactions successfully exported. Please check your email.';
  const errorText = 'We were unable to export your transactions. Please try again.';

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <Flash
      variant={type}
      onDismiss={() => {
        setShouldShowBanner(false);
      }}
      mt="0"
      mb="8"
    >
      <Text>{type === 'success' ? successText : errorText}</Text>
    </Flash>
  );
};
